const customMethods = {
	list: { method: 'GET', url: 'housemaid-list' },
	housekeepingRooms: { method: 'GET', url: 'housekeeping-rooms' },
};

function housemaid(vm) {
	return vm.$resource('housemaid{/id}', {}, customMethods);
}

export default housemaid;



// WEBPACK FOOTER //
// ./src/resource/housemaid.js